
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LegacyJob } from '../types';

// 使用 LegacyJob 类型用于向后兼容
type Job = LegacyJob;

interface ApplicationSuccessProps {
  job: Job;
  onBack: () => void;
}

const ApplicationSuccess: React.FC<ApplicationSuccessProps> = ({ job, onBack }) => {
  const { t } = useTranslation();
  return (
    <div className="pt-32 pb-32 bg-white min-h-[calc(100vh-4rem)] flex items-center justify-center">
      <div className="max-w-xl mx-auto px-6 text-center relative z-0">
        {/* Animated Check Icon */}
        <div className="relative w-32 h-32 mx-auto mb-10">
          <div className="absolute inset-0 bg-blue-500/10 rounded-full animate-ping pointer-events-none"></div>
          <div className="relative w-full h-full bg-blue-600 rounded-3xl flex items-center justify-center shadow-2xl shadow-blue-500/40">
            <svg className="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <h1 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight mb-6 leading-tight">
          {t('applicationSuccess.title')}
        </h1>
        <p className="text-xl text-slate-500 font-medium mb-12 leading-relaxed">
          {t('applicationSuccess.subtitle', { position: job.title })}
        </p>

        {/* Info Card */}
        <div className="bg-slate-50 border border-slate-100 rounded-xl p-8 mb-12 text-left">
           <div className="flex items-center gap-4 mb-6">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm text-blue-600">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <div className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{t('applicationSuccess.confirmationLabel')}</div>
                <div className="text-sm font-bold text-slate-700">{t('applicationSuccess.confirmationDesc')}</div>
              </div>
           </div>
           <div className="flex items-center gap-4">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm text-amber-600">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <div>
                <div className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{t('applicationSuccess.nextStepLabel')}</div>
                <div className="text-sm font-bold text-slate-700">{t('applicationSuccess.nextStepDesc')}</div>
              </div>
           </div>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onBack}
            className="w-full sm:w-auto bg-slate-900 text-white px-10 py-4 rounded-xl font-black text-lg hover:bg-blue-600 hover:shadow-xl transition-all shadow-xl shadow-slate-200 active:scale-95 cursor-pointer"
          >
            {t('applicationSuccess.backBtn')}
          </button>
          <button className="w-full sm:w-auto bg-white text-slate-500 border border-slate-200 px-10 py-4 rounded-xl font-black text-lg hover:bg-slate-50 hover:shadow-lg transition-all cursor-pointer">
            {t('applicationSuccess.profileBtn')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ApplicationSuccess);
